import ErrorHandler from 'store/utils/ErrorHandler';
import Notify from 'store/utils/Notify';
import * as types from './actionTypes';
import * as api from './api';
import * as selectors from './selectors';
import initialState from './initialState';

/**
 * Get Notifications List
 */
export const getNotificationsList = (params = {}) => async (
  dispatch,
  getState,
) => {
  try {
    await dispatch({
      type: types.GET_NOTIFICATIONS_LIST_REQUEST,
    });

    const existingParams = selectors.getPaginationOptions(getState());
    const finalParams = {
      ...existingParams,
      ...params,
      created_at__lt: existingParams.created_at__lt || new Date().toISOString(),
    };

    const { data } = await api.getNotificationListRequest(finalParams);

    await dispatch({
      type: types.GET_NOTIFICATIONS_LIST_SUCCESS,
      payload: {
        notifications: data.results,
        count: data.count,
        paginationOptions: finalParams,
      },
    });
  } catch (error) {
    await dispatch({
      type: types.GET_NOTIFICATIONS_LIST_ERROR,
      payload: {
        error: error.message,
      },
    });

    Notify.error({
      title: 'An error occurred',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};

/**
 * Refresh Notifications List
 */
export const refreshNotificationsList = () => async dispatch => {
  try {
    await dispatch({
      type: types.GET_NOTIFICATIONS_LIST_REQUEST,
    });

    const { paginationOptions } = initialState.list;

    const { data } = await api.getNotificationListRequest(paginationOptions);

    await dispatch({
      type: types.REFRESH_NOTIFICATIONS_LIST_SUCCESS,
      payload: {
        notifications: data.results,
        count: data.count,
        paginationOptions,
      },
    });
  } catch (error) {
    await dispatch({
      type: types.GET_NOTIFICATIONS_LIST_ERROR,
      payload: {
        error: error.message,
      },
    });

    Notify.error({
      title: 'An error occurred',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};

/**
 * Get Notifications count
 */
/* eslint-disable consistent-return */
export const getNotificationsCount = () => async dispatch => {
  try {
    dispatch({
      type: types.GET_NOTIFICATIONS_COUNT_REQUEST,
    });

    const { data } = await api.getNotificationsCountRequest();

    dispatch({
      type: types.GET_NOTIFICATIONS_COUNT_SUCCESS,
      payload: {
        count: data.count,
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_NOTIFICATIONS_COUNT_ERROR,
      payload: {
        error: error.message,
      },
    });

    Notify.error({
      title: 'An error occurred',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};

/**
 * Mark all Notifications as read ones
 */
export const markNotificationsAsRead = () => async dispatch => {
  try {
    await dispatch({
      type: types.MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST,
    });

    await api.markNotificationsAsRead();

    await dispatch({
      type: types.MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS,
      payload: {
        count: 0,
      },
    });
  } catch (error) {
    await dispatch({
      type: types.MARK_ALL_NOTIFICATIONS_AS_READ_ERROR,
      payload: {
        error: error.message,
      },
    });

    Notify.error({
      title: 'An error occurred',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};
